import React from 'react';
import './List.scss';

export type ListProps = {
  id: string;
  title?: string;
  listItems: string[];
  icon?: React.ReactNode;
};

export const List = ({
  id,
  title,
  listItems,
  icon
}: ListProps): JSX.Element => {
  const iconListClass = icon ? 'fa-ul' : 'no-icon';

  return (
    <div id={id} className='list-widget'>
      {title && <div className='list-widget-title'>{title}</div>}
      <ul className={iconListClass}>
        {listItems.map((item, i) => (
          <li key={`${id}-${i}`}>
            {icon}
            <span className='item-text'>{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default List;
